// This file was autogenerated from /frontend/sail-next/packages/docs/src/examples/TailorDateField/Error.story.tsx with go/sail-next-tailor-docs-publisher

import * as React from 'react';
import {TailorDateField} from '@sail/ui';

export const Error = () => (
  <TailorDateField
    label="Date of birth"
    description="Enter your birthday"
    defaultValue="2099-02-31"
    invalid
    error="Invalid birthday"
  />
);
